import MyMapsContextMenu, { TMymapsContextMenuName, TMymapsContextMenuPlaces } from "~/es6/mymaps.contextmenu";
import { icon, node } from "~/util/dom";

interface ICreateContextMenuBtn {
	place: TMymapsContextMenuPlaces;
	clickCb: (name: TMymapsContextMenuName) => void;
}

export function createContextMenuBtn({
	place,
	clickCb,
}: ICreateContextMenuBtn) {
	const editBtn = node("button", { className: "context-menu-btn" });
	const contextMenu = new MyMapsContextMenu({
		clickCb,
		place,
	});

	editBtn.appendChild(icon("etc-vertical"));
	contextMenu.container.classList.add("context-menu-btn-list");
	editBtn.append(contextMenu.container);
	editBtn.addEventListener("click", () => {
		contextMenu.open();
	});

	return {
		container: editBtn,
		show: () => {
			editBtn.classList.remove("hide");
		},
		hide: () => {
			editBtn.classList.add("hide");
		},
	};
}
